<template lang="pug">
    .keyCircles-container(:class="[spacingTop, spacingBottom]")
      .container.mx-auto
        .keyCircles-wrap
          Panel(
            v-for="( panel, i ) in accordion"
            :key="panel.id"
            :index="i"
            :panel="panel"
          )
</template>

<script>
//import AOS from 'aos';
import { get, cloneDeep } from '@/helpers';
import Panel from './Panel';

export default {
    name: 'KeyCircles',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Panel
    },
    computed: {
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        accordion() {
            let accordion = this.section.contents || [];
            return cloneDeep(accordion).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.keyCircles-wrap
  @apply flex justify-center
</style>
